<rid-mechanic-background />

@let _state = state();

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Dictee | Visueel" [steps]="words().length" [progress]="index()" />

  <rid-mechanic-content>
    @if (_state !== 'FEEDBACK') {
      @for (title of [_state === 'PREVIEW' ? 'Kijk goed naar het woord' : 'Schrijf het woord in je schrift']; track title) {
        <rid-mechanic-title [title]="title" animate.enter="wait-500" />
      }
    }

    @if (_state === 'PREVIEW') {
      @for (input of [word().word]; track input) {
        <div class="absolute flex flex-col place-items-center gap-8" animate.leave="anim-fade-out">
          <div
            class="font-default isolate min-w-60 rounded-lg border-3 border-white bg-white px-8 py-6 text-center text-4xl xl:min-w-80 xl:text-6xl"
            animate.enter="wait-1000 anim-pop-in"
            ridSfx="BUBBLE_POP"
          >
            <rid-word [word]="input" />
          </div>
        </div>
      }
    }

    @if (_state === 'FEEDBACK') {
      <div class="absolute flex flex-col place-items-center gap-8" animate.leave="anim-fade-out">
        <rid-segmented-word-card
          #segmentedWordCard
          [segments]="segmentsMap().get(index())!"
          animate.enter="anim-pop-in"
          animate.leave="anim-pop-out"
          ridSfx="HINT"
          (mouseenter)="segmentedWordCard.decompress()"
          (mouseleave)="segmentedWordCard.compress()"
        />
      </div>
    }

    @if (state() === 'WRITING') {
      <rid-bottom-button content="Klaar!" animate.enter="wait-2000" (clicked)="state.set('FEEDBACK')" />
    }

    @if (state() === 'FEEDBACK') {
      <rid-assessment-toast (assessed)="$event === 'CORRECT' ? markCorrect() : markIncorrect()" />
    }

    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
